import { render, staticRenderFns } from "./RsaAccettazioneViewComponent.vue?vue&type=template&id=23671096"
import script from "./RsaAccettazioneViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports